import type { OutcomeParameterValue } from '../../../types';

type CoefsBoundsByTotal = Map<
    OutcomeParameterValue,
    {
        min: number;
        max: number;
        hasPairOutcomes: boolean;
    }
>;

export const createProfitableTotalSelector = () => {
    const coefsBoundsByTotal: CoefsBoundsByTotal = new Map();

    /**
     * Добавляет коэффициент исхода в Map для расчёта наиболее выгодного дробного тотала.
     * Учитываются только значения вида: 0,5 и -0,5
     *
     * Информация из ТЗ: Если выбран рынок Тотал и игровой период Матч, то показать наиболее выгодный для БК тотал.
     * То есть дробный тотал и коэффициенты которого ближе друг к другу (по такой же логике сейчас показываются тоталы в Линии)
    */
    const addCoefByNumericValue = (
        numericValueForIndex: OutcomeParameterValue,
        coef: number,
    ): void => {
        const numericValue = Number(numericValueForIndex.replace(',', '.'));

        // Если тотал не дробный, не рассматриваем его (он не может быть самым выгодным по умолчанию)
        if (Math.abs(numericValue % 1) !== 0.5) {
            return;
        }

        const bounds = coefsBoundsByTotal.get(numericValueForIndex);

        if (!bounds) {
            coefsBoundsByTotal.set(numericValueForIndex, { min: coef, max: coef, hasPairOutcomes: false });
            return;
        }

        bounds.min = Math.min(bounds.min, coef);
        bounds.max = Math.max(bounds.max, coef);
        bounds.hasPairOutcomes = true;
    }

    /**
     * Находит тотал, для которого два коэффициента имеют минимальную разницу.
     */
    const findProfitableNumericValue = (): OutcomeParameterValue | undefined => {
        let profitableNumericValue: OutcomeParameterValue | undefined;
        let minDifference = Infinity;

        for (const [paramValue, bounds] of coefsBoundsByTotal) {
            // Нужен тотал, у которого два кэфа.
            if (!bounds.hasPairOutcomes) {
                continue;
            }

            const difference = bounds.max - bounds.min;

            if (difference < minDifference) {
                minDifference = difference;
                profitableNumericValue = paramValue;
            }
        }
        return profitableNumericValue;
    }

    return {
        addCoefByNumericValue,
        findProfitableNumericValue,
    };
}